import React from "react";
import { Link } from "react-router-dom";
import { reopenConsent } from "../consent";
import AdsLeaderboard from "../components/AdsLeaderboard";

const AppFooter = () => {
  return (
    <footer className="page-footer grey lighten-4">
      <AdsLeaderboard position="large-bot-leaderboard" googleads="true" />
      <div className="container">
        <div className="row">
          <div className="col s12 m6">
            <Link className="deep-orange-text text-darken-1" to="/">
              știri de <b>Sibiu</b>
            </Link>
            <ul className="">
              <li>
                <Link
                  className="grey-text text-darken-2"
                  to="/confidentialitate"
                >
                  Politică de Confidențialitate
                </Link>
              </li>
              <li>
                <Link className="grey-text text-darken-2" to="/cookies">
                  Politică de Cookies
                </Link>
              </li>
              <li>
                <a
                  className="grey-text text-darken-2"
                  href="/cookies"
                  onClick={(e) => {
                    e.preventDefault();
                    reopenConsent();
                  }}
                >
                  Setări cookies
                </a>
              </li>
              <li>
                <Link className="grey-text text-darken-2" to="/">
                  Acasă
                </Link>
              </li>
              <li>
                <Link className="grey-text text-darken-2" to="/stiri">
                  Știri
                </Link>
              </li>
              <li>
                <Link className="grey-text text-darken-2" to="/contact">
                  Contact
                </Link>
              </li>
              <li>
                <a className='grey-text text-darken-2' href='https://rss.stiridesibiu.ro' target={'_blank'} rel='noopener noreferrer'>RSS</a>
              </li>
            </ul>
          </div>
          <div className="col s12 m6">
            <h6 className="deep-orange-text">Contactează-ne la</h6>
            <span className="grey-text text-darken-2">
              <b>E-mail:</b> redactie@stiridesibiu.ro
            </span>
            <br />
            <span className="grey-text text-darken-2">
              <b>Telefon:</b> 0746.773.513
            </span>
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        <div className="container deep-orange-text">
          © 2021 Stiri de Sibiu
          <Link
            className="grey-text text-darken-2 right"
            to="/confidentialitate"
          >
            Politică de Confidențialitate
          </Link>
          <span className="right" style={{ marginRight: 5, marginLeft: 5 }}>
            {" "}
            |{" "}
          </span>
          <Link className="grey-text text-darken-2 right" to="/cookies">
            Politică de Cookies
          </Link>
          <span className="right" style={{ marginRight: 5, marginLeft: 5 }}>
            {" "}
            |{" "}
          </span>
          <Link className="grey-text text-darken-2 right" to="/sitemap">
            Sitemap
          </Link>
          <span className="right" style={{ marginRight: 5, marginLeft: 5 }}>
            {" "}
            |{" "}
          </span>
          <a href="https://trafic.ro/statistici/stiridesibiu.ro" rel="noopener noreferrer" target="_blank">
            <img src="https://trafic.ro/images/trafic-ro-logo_transparent.png" title="Trafic.ro - Clasamente si Statistici" style={{ height:"25px" }} alt="Trafic.ro"/>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
